import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

const STATUS = ['new','in_progress','converted','closed'];

export default function OwnerEnquiries() {
  const [list, setList] = useState([]);
  const [err, setErr] = useState('');

  const load = async () => { try { const {data} = await api.get('/owner/enquiries'); setList(data.enquiries||[]); } catch(e){ setErr(apiError(e)); } };
  useEffect(() => { load(); }, []);

  const upd = async (e_, patch) => { await api.put(`/owner/enquiries/${e_.id}`, patch); await load(); };

  return (
    <div data-testid="owner-enquiries">
      <h2 className="mb-3">Enquiries for my businesses</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="row g-3">
        {list.map(e => (
          <div className="col-md-6" key={e.id}>
            <div className="ap-card" data-testid={`owner-enq-${e.id}`}>
              <div className="d-flex justify-content-between">
                <div>
                  <div className="fw-bold">{e.customer_name}</div>
                  <div className="small text-muted-2">{e.business_name} · {e.source}</div>
                </div>
                <span className={'pill pill-'+e.status}>{e.status}</span>
              </div>
              <p className="mt-2">{e.message}</p>
              <div className="d-flex gap-2 flex-wrap">
                <select className="form-select form-select-sm" style={{maxWidth:180}} value={e.status} onChange={ev=>upd(e, { status: ev.target.value })} data-testid={`owner-enq-status-${e.id}`}>
                  {STATUS.map(s=> <option key={s} value={s}>{s}</option>)}
                </select>
                {e.customer_phone && <a className="btn-call btn-sm" href={`tel:${e.customer_phone}`}>Call</a>}
                {e.customer_phone && <a className="btn-wa btn-sm" href={`https://wa.me/${e.customer_phone.replace(/[^0-9]/g,'')}`} target="_blank" rel="noreferrer">WhatsApp</a>}
              </div>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="ap-card">No enquiries yet.</div>}
      </div>
    </div>
  );
}
